import { render, staticRenderFns } from "./PopupCreate.vue?vue&type=template&id=81490bfa&"
import script from "./PopupCreate.vue?vue&type=script&lang=js&"
export * from "./PopupCreate.vue?vue&type=script&lang=js&"
import style0 from "./PopupCreate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PopupCreate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports